import { render, staticRenderFns } from "./clickbuy.layout.vue?vue&type=template&id=299a1726&scoped=true&lang=pug"
import script from "./clickbuy.layout.vue?vue&type=script&lang=ts"
export * from "./clickbuy.layout.vue?vue&type=script&lang=ts"
import style0 from "./clickbuy.layout.vue?vue&type=style&index=0&id=299a1726&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "299a1726",
  null
  
)

export default component.exports